/**
 * Topic-name search that does not care about British vs American spelling.
 *
 * "Factorisation" did not substring-match the "Factorization" chapter, so a
 * teacher searching the way their textbook spells it concluded the topic did
 * not exist. Both the query and the name are folded (`iz`→`is`, `yz`→`ys`)
 * before the substring test — applied to both sides, so it can only add matches,
 * never lose one. Folding partial words too means "factoris" finds it mid-typing.
 */
export function foldSpelling(s: string): string {
  return s.toLowerCase().trim().replace(/iz/g, 'is').replace(/yz/g, 'ys');
}

/** Does `name` contain the (already folded) query? */
export function nameMatches(name: string, foldedQuery: string): boolean {
  return foldSpelling(name).includes(foldedQuery);
}
